import { Injectable, OnDestroy } from '@angular/core';
import { EventClass } from '../utils/event-class';
import { interval, Subject } from 'rxjs';

@Injectable()
export class InteractionService implements OnDestroy {
     private timer: any;
     maxSessionInactivity = window.app.conf.autoDisconnect;
     maxSessionInactivitySecond = window.app.conf.autoDisconnect / 1000;
     disconnect$ = new Subject<boolean>();
     timeLeft$ = new Subject<number>();
     _isStopped = false;
     _elapsedTime = 0;
     private eventClass = new EventClass(document.querySelector('body'));
     private _clickEvent = 'click.interaction';
     private _keyUpEvent = 'keyup';
     private _interval = interval(1000).subscribe(() => this.checkState());

     constructor() {
          const eventHandler = () => {
               this.reset();
          };
          this.eventClass.addEventListener(
               this._clickEvent,
               eventHandler.bind(this)
          );
          this.eventClass.addEventListener(
               this._keyUpEvent,
               eventHandler.bind(this)
          );
     }

     ngOnDestroy() {
          try {
               this._interval.unsubscribe();
          } catch (e) {}
          if (this.eventClass) {
               this.eventClass.removeEventListener(this._clickEvent);
               this.eventClass.removeEventListener(this._keyUpEvent);
          }
     }

     reset() {
          if (this._isStopped || this.maxSessionInactivitySecond === 0) {
               return void 0;
          }
          this._elapsedTime = 0;
          if (this.timer) {
               clearTimeout(this.timer);
               this.timer = null;
          }
          this.timer = setTimeout(() => {
               this.disconnect$.next(null);
          }, this.maxSessionInactivity);
     }

     private checkState() {
          if (!this._isStopped && this.maxSessionInactivitySecond !== 0) {
               if (this._elapsedTime >= this.maxSessionInactivitySecond) {
                    this._elapsedTime = 0;
                    this.disconnect$.next(null);
               } else {
                    this._elapsedTime++;
                    this.timeLeft$.next(
                         this.maxSessionInactivitySecond - this._elapsedTime
                    );
               }
          }
     }

     stop() {
          this._isStopped = true;
          this.reset();
     }

     start() {
          this._isStopped = false;
          this.reset();
     }
}
